import React from 'react';
export function BottomLinksSection() {
  return <div className="text-center pt-8 border-t border-gray-200" data-id="element-2984">
      <div className="flex flex-wrap justify-center items-center gap-4 text-lg font-bold" data-id="element-2985">
        <a href="59m7/agiecharmilles-edm/wire-edm.html" className="text-orange hover:underline" data-id="element-2986">
          AgieCharmilles Wire EDM
        </a>
        <span className="text-gray-400" data-id="element-2987">|</span>
        <a href="59m7/agiecharmilles-edm/sinker-edm.html" className="text-orange hover:underline" data-id="element-2988">
          AgieCharmilles Sinker EDM
        </a>
        <span className="text-gray-400" data-id="element-2989">|</span>
        <a href="/QuoteEDMConsumables.html" className="text-orange hover:underline" data-id="element-2990">
          EDM Consumables
        </a>
      </div>
    </div>;
}